/** Distancia en km entre dos puntos WGS84 (fórmula de Haversine). */
export function haversineKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371;
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export type CiudadConCentro = {
  id: number;
  nombre: string;
  latitud_centro: number | null;
  longitud_centro: number | null;
};

export function findNearestCiudad(
  userLat: number,
  userLng: number,
  ciudades: CiudadConCentro[]
): { ciudad: CiudadConCentro; distanceKm: number } | null {
  const withCoords = ciudades.filter(
    (c) =>
      c.latitud_centro != null &&
      c.longitud_centro != null &&
      !Number.isNaN(c.latitud_centro) &&
      !Number.isNaN(c.longitud_centro)
  );
  if (withCoords.length === 0) return null;

  let best = withCoords[0];
  let bestD = haversineKm(userLat, userLng, best.latitud_centro!, best.longitud_centro!);
  for (let i = 1; i < withCoords.length; i++) {
    const c = withCoords[i];
    const d = haversineKm(userLat, userLng, c.latitud_centro!, c.longitud_centro!);
    if (d < bestD) {
      bestD = d;
      best = c;
    }
  }
  return { ciudad: best, distanceKm: bestD };
}
